<template>
  <div class="card-panel footer-card-panel">
    <!-- START: views/footer.tmpl.html -->
    <div class="row">
      <div class="col s12 m6 l3 footer-col">
        <h3><i class="material-icons quaese">receipt</i>Quaese</h3>
        <p>Ein Überblick über meine Kompetenzen und meinen Werdegang.</p>
      </div>
      <div class="col s12 m6 l3 footer-col">
        <h3><i class="material-icons projects">navigation</i>Projekte</h3>
        <p>
          Ein Querschnitt durch meine Arbeiten und Projekte der letzten Jahre.
        </p>
      </div>

      <div class="col s12 m6 l3 footer-col">
        <h3><i class="material-icons impress">gavel</i>Impressum</h3>
        <p>
          <a
            :href="`#/impress?scroll=${encodeURIComponent('#section_02')}`"
            title="Datenschutzerklärung"
            >Datenschutzerklärung</a
          >,
          <a href="#/impress" title="Impressum">Impressum</a>
          und sonstige notwendige rechtiche Informationen.
        </p>
      </div>
      <div class="col s12 m6 l3 footer-col">
        <h3><i class="material-icons contact">contact_mail</i>Kontakt</h3>
        <p>
          Markus Höllein<br />
          Rathenaustraße 2<br />
          07745 Jena<br />
        </p>
        <p class="mail">
          <i class="material-icons">mail_outline</i> quaese(at)quaese.de
        </p>
      </div>
    </div>
    <!-- END: views/footer.tmpl.html -->
  </div>
</template>

<script>
export default {
  name: "base-footer"
};
</script>
